<template>
  <div class="pthv-form pthvSchedule-form form">

    <div class="form-item form-type-select">
      <label class="form-label" for="pthv-line-select">{{ $t("isearchMyLine") }}</label>
      <div class="form-input form-input--type-select has-icon has-icon--end">
        <select v-model="selectedLine" @change="selectLine" id="pthv-line-select" class="form-select form-input form-input--type-select has-icon has-icon--end form-select--alternative">
          <option value="all">{{ $t("chooseLine") }}</option>
          <template v-if="withDestinations && hasCategories">
            <optgroup v-for="(lineCategory, categoryKey) in stopsByLineCategorised" :label="lineCategory.category">
              <template v-for="(lineStops, lineKey) in lineCategory.lineStops">
                <ApthScheduleLineOptions v-for="(stop, destKey) in lineStops.stopsByDestinations"
                  :categoryKey="categoryKey" :lineKey="lineKey" :finalKey="destKey"
                  :lineMnemo="lineStops.line.mnemo" :stop="stop" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
                />
              </template>
            </optgroup>
          </template>
          <template v-else-if="withDestinations">
            <template v-for="(lineCategory, categoryKey) in stopsByLineCategorised">
              <template v-for="(lineStops, lineKey) in lineCategory.lineStops">
                <ApthScheduleLineOptions v-for="(stop, destKey) in lineStops.stopsByDestinations"
                  :lineKey="lineKey" :finalKey="destKey"
                  :lineMnemo="lineStops.line.mnemo" :stop="stop" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
                />
              </template>
            </template>
          </template>
          <template v-else-if="hasCategories">
            <optgroup v-for="(lineCategory, categoryKey) in stopsByLineCategorised" :label="lineCategory.category">
              <ApthScheduleLineOptions v-for="(stop, lineKey) in lineCategory.lineStops"
                :stop="stop" :finalKey="lineKey" :categoryKey="categoryKey" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
              />
            </optgroup>
          </template>
          <template v-else>
            <template v-for="(lineCategory, categoryKey) in stopsByLineCategorised">
              <ApthScheduleLineOptions v-for="(stop, lineKey) in lineCategory.lineStops"
                :stop="stop" :finalKey="lineKey" :withDestinations="withDestinations" :optionSeparator="optionSeparator"
              />
            </template>
          </template>
        </select>
        <div class="after">
          <svg class="icon icon--primary icon--md not-actionable" tabindex="-1" role="img" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 8.29289C5.68342 7.90237 6.31658 7.90237 6.70711 8.29289L12 13.5858L17.2929 8.29289C17.6834 7.90237 18.3166 7.90237 18.7071 8.29289C19.0976 8.68342 19.0976 9.31658 18.7071 9.70711L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289Z" fill="currentColor"></path></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//Components
import ApthScheduleLineOptions from "./ApthScheduleLineOptions";

export default {
  name: "ApthScheduleForm",
  components: {
    ApthScheduleLineOptions,
  },
  data() {
    return {
      selectedLine: "all",
      selectedStop: "all",
      stopsRefs: [],
      optionSeparator: "||",
    };
  },
  props: {
    lines: {
      type: Object,
      required: true,
      default: () => {
        return [];
      }
    },
    stopsByLineCategorised: {
      type: Array,
      required: true,
      default: [],
    },
    stops: {
      type: Object,
      required: true,
      default: () => {
        return [];
      }
    },
    withDestinations: {
      type: Boolean,
      required: false,
      default: true
    },
    hasCategories: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    selectLine: function() {
      let ss = this.stops;
      const expandName = function(stopRef) {
        return {
          name: ss[stopRef].name,
          refs: [stopRef]
        };
      };

      const uniqueStopsRefs = function(stopsRefs) {
        // Transform objects to strings
        let comparablesStops = stopsRefs.map(
          s => s.name + "<>" + s.refs.join("§")
        );
        // Make unique
        let uniqueStops = new Set(comparablesStops);
        //Reconstruct arrays
        return Array.from(uniqueStops).map(str => {
          let parts = str.split("<>");
          let name = parts[0];
          let refs = parts[1].split("§");
          return {
            name: name,
            refs: refs
          };
        });
      };

      const mergeStopareas = function(stopareas) {
        let merged = [];
        for (let stoparea of stopareas) {
          if (Object.keys(merged).indexOf(stoparea.name) < 0) {
            merged[stoparea.name] = stoparea;
          } else {
            merged[stoparea.name].refs = merged[stoparea.name].refs.concat(
              stoparea.refs
            );
          }
        }
        return Object.values(merged);
      };

      let selectedLineParts = String(this.selectedLine).split(this.optionSeparator);
      let categoryId = selectedLineParts[0];
      let lineId = selectedLineParts[1];

      // We have no values if 'all' is selected
      // Check the values before building stops list
      if (this.stopsByLineCategorised[categoryId] !== undefined && lineId !== undefined) {
        let stopsByLine = this.stopsByLineCategorised[categoryId].lineStops[lineId];
        let stopareas;
        if (this.withDestinations) {
          let direction = selectedLineParts[2];
          let stopsByDestination = stopsByLine.stopsByDestinations[direction];
          stopareas = stopsByDestination.stopsRefs.map(expandName);
        } else {
          stopareas = stopsByLine.stopsByDestinations.flatMap(stopsByDest =>
            stopsByDest.stopsRefs.map(expandName)
          );
        }
        this.stopsRefs = uniqueStopsRefs(mergeStopareas(stopareas));

        this.$emit("selectLine", stopsByLine.line);
      } else {
          this.$emit("selectLine", []);
      }
    }
  }
};
</script>
